import React from 'react';
import Icon from '../atoms/Icon';

function ArmIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 27 32">
      <g
        fill='none'
        fillRule='nonzero'
        stroke="currentColor"
        stroke-width="2.63636"
        stroke-miterlimit="10"
      >
        <path d='M17.1364 1.38751C17.1364 1.38751 13.1818 2.26015 13.1818 5.34206C13.1818 8.42397 17.1364 9.2966 17.1364 9.2966C17.1364 9.2966 14.6186 15.2785 16.7594 21.1602H14.4341C14.1111 18.9272 12.209 17.2057 9.88636 17.2057C7.56372 17.2057 1.31818 21.1602 1.31818 21.1602V27.7511C1.31818 27.7511 6.62913 30.3875 13.1818 30.3875C19.7345 30.3875 25.0454 27.7511 25.0454 27.7511C25.0454 14.7631 22.1889 5.23924 21.0909 4.02388C19.9929 2.80851 17.1364 1.38751 17.1364 1.38751Z'/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(ArmIcon);
